class Project {
  constructor({
    id,
    title,
    description,
    technologies = [],
    role,
    features = [],
    repoUrl,
    liveUrl,
    imageUrl,
    startDate,
    endDate
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.technologies = technologies;
    this.role = role;
    this.features = features;
    this.repoUrl = repoUrl;
    this.liveUrl = liveUrl;
    this.imageUrl = imageUrl;
    this.startDate = startDate;
    this.endDate = endDate;
  }

  getDuration() {
    if (!this.startDate || !this.endDate) return null;
    const start = new Date(this.startDate);
    const end = new Date(this.endDate);
    return `${Math.round(
      (end - start) / (1000 * 60 * 60 * 24 * 30)
    )} months`;
  }

  hasTech(tech) {
    return this.technologies.includes(tech);
  }
}
export default Project;